import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function saveBackofficePermission({ permissions }) {
  const backOfficePermission = {
    'View Dashboard': false,
    'View Reports': false,
    Sales: false,
    Transactions: false,
    Invoices: false,
    Shifts: false,
    'Manage Library': false,
    'Item Library': false,
    Modifiers: false,
    'Item Categories': false,
    Promos: false,
    Discounts: false,
    'Sales Types': false,
    'Manage Ingredients': false,
    'Ingredient Library': false,
    'Ingredient Categories': false,
    Recipes: false,
    'Manage Inventory': false,
    'Inventory Summary': false,
    Suppliers: false,
    'Purchase Orders (PO)': false,
    Transfers: false,
    Adjustments: false,
    'Manage Customers': false,
    'Customer List': false,
    Feedback: false,
    'Loyalty Program': false,
    'Manage Employees': false,
    'Employee Slots': false,
    'Manage Table Management': false,
    'Table Groups': false,
    'Table Map': false,
    'Table Reports': false,
    'Manage Account Settings': false,
    Receipts: false,
    'Email Notifications': false,
  };

  permissions.forEach(permission => {
    const { menu_name: menuName, sub_menu_name: subMenuName } = permission;
    backOfficePermission[subMenuName] = true;
    backOfficePermission[menuName] = true;
  });

  pushClevertapEvent('Configure Backoffice Permission', backOfficePermission);
}

export function saveMobilePermission({ permissions }) {
  const appPermission = {
    'Issue Refunds': false,
    'Manage All Open Bills': false,
    'Resend Receipts': false,
    'Record Invoice Payments': false,
    'Cancel Invoices': false,
    'View and Print Current Shift Details': false,
    'Manage Discounts': false,
    'Manage Items': false,
    'Manage Favorites': false,
    'Edit Customer Information': false,
    'Move Tables': false,
    'Charge Customers': false,
  };

  permissions.forEach(permission => {
    const { sub_menu_name: subMenuName } = permission;
    appPermission[subMenuName] = true;
  });

  pushClevertapEvent('Configure Mobile Permission', appPermission);
}
